module.exports = __webpack_public_path__ + "media/icons/card-3-183384ca.png";